export enum IDS_INPUTS {
  CART_ZIP_CODE = 'CART_ZIP_CODE',
}

export enum USER_AREA {
  ADDRESSES_WRAPPER = 'ADDRESSES_WRAPPER',
}
